import { 
  CheckSquare, 
  FileText, 
  Calculator, 
  BookOpen, 
  Target, 
  Download, 
  Shield,
  Lock,
  FileCheck,
  AlertTriangle,
  ClipboardCheck,
  Database,
  Key,
  FileSearch,
  Mail,
  Network,
  Users,
  Building2,
  GraduationCap,
  UserCheck,
  CheckCircle2,
  Package,
  ShieldCheck,
  ShieldAlert
} from "lucide-react";

export const iconMap: Record<string, any> = {
  'CheckSquare': CheckSquare,
  'FileText': FileText,
  'Calculator': Calculator,
  'BookOpen': BookOpen,
  'Target': Target,
  'Download': Download,
  'Shield': Shield,
  'Lock': Lock,
  'FileCheck': FileCheck,
  'AlertTriangle': AlertTriangle,
  'ClipboardCheck': ClipboardCheck,
  'Database': Database,
  'Key': Key,
  'FileSearch': FileSearch,
  'Mail': Mail,
  'Network': Network,
  'Users': Users,
  'Building2': Building2,
  'GraduationCap': GraduationCap,
  'UserCheck': UserCheck,
  'CheckCircle2': CheckCircle2,
  'Package': Package,
  'ShieldCheck': ShieldCheck,
  'ShieldAlert': ShieldAlert,
};

export const availableIcons = Object.keys(iconMap);

export const getIconComponent = (iconName: string) => {
  return iconMap[iconName] || FileText; // Default to FileText if icon not found
};
